import { Typography, Stack, Tooltip} from '@mui/material';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import { CheckBadgeIcon, ShieldCheckIcon, } from '@heroicons/react/24/solid'
import SecurityIcon from '@mui/icons-material/Security';
import HealthAndSafetyOutlinedIcon from '@mui/icons-material/HealthAndSafetyOutlined';
import AccessibilityNewOutlinedIcon from '@mui/icons-material/AccessibilityNewOutlined';

function UserName(props) {
  let { user, className, style, sx, component, to, color, paragraph, showTooltips = false} = props;
  if (!user) return null;
  if (user.raw) user= user.raw;
  const isHalespring= user.status === 'staff';
  const isVerified= user.status === 'verified';
  const isNPIVerified= user.status === 'npiverified';
  const isIdentified= user.status === 'identified' || user.status === 'indent_verified';
  const isEnhanced= user.providerInfo?.enhancedProfile;
  const isProvider= user.type === 'provider';
  const showEnhanced= isVerified && !isHalespring && isEnhanced;
  const showIdentBadge= (isVerified || isIdentified || isNPIVerified) && !isHalespring;
  const showVerifiedBadge= isVerified && !isHalespring;
  const preferences= user.namePreferences ? user.namePreferences :
      user.providerInfo?.namePreferences ? user.providerInfo.namePreferences :
          "prefix,suffix";
  const hasLicenses= user.providerInfo?.licenses && user.providerInfo.licenses.length > 0;
  const hasCredentials= user.providerInfo?.credentials && user.providerInfo.credentials.length > 0;
  const hasCertifications= user.providerInfo?.certifications && user.providerInfo.certifications.length > 0;
  const credentials= hasCredentials && preferences.includes("credentials") ? " " + user.providerInfo.credentials.join()  : "";
  const licenses= hasLicenses && preferences.includes("licenses") ?  (credentials ? "," : " ") + user.providerInfo.licenses.map(l => l?.licenseType).filter(Boolean).join()  : "";
  const certifications= hasCertifications && preferences.includes("certifications") ?  ((credentials || licenses) ? "," : " ") + user.providerInfo.certifications.join()  : "";

  const prefix= user.prefix && preferences.includes("prefix") ? user.prefix + " " : "";
  const suffix= user.suffix && preferences.includes("suffix") ? " " + user.suffix : "";
  
  return (
	  <Stack direction="row" alignItems="center">
		  <Typography
	              sx={sx}
	              className={className}
	              style={style}
	              component={component}
	              to={to}
	              color={color}
	              paragraph={paragraph}
	            >
	              {prefix + user.firstName + " " + user.lastName + suffix + credentials + licenses + certifications}
	              
	      </Typography>

          {isProvider && (
            showTooltips ? (
              <Tooltip title="Healthcare Provider">
                <HealthAndSafetyOutlinedIcon className="h-16 w-16 text-slate-500" />
              </Tooltip>
            ) : (
              <HealthAndSafetyOutlinedIcon className="h-16 w-16 text-slate-500" />
            )
          )}
          {!isProvider && (
            showTooltips ? (
              <Tooltip title="User (non-Provider)">
                <AccessibilityNewOutlinedIcon className="h-16 w-16 text-slate-500" />
              </Tooltip>
            ) : (
              <AccessibilityNewOutlinedIcon className="h-16 w-16 text-slate-500" />
            )
          )}
	      {showIdentBadge && (
            showTooltips ? (
              <Tooltip title="Identity Verified">
                <SecurityIcon className="h-16 w-16 text-slate-500" />
              </Tooltip>
            ) : (
              <SecurityIcon className="h-16 w-16 text-slate-500" />
            )
          )}
	      {showVerifiedBadge && (
            showTooltips ? (
              <Tooltip title="License Verified">
                <ShieldCheckIcon className="h-16 w-16 text-green-500" />
              </Tooltip>
            ) : (
              <ShieldCheckIcon className="h-16 w-16 text-green-500" />
            )
          )}
	      {showEnhanced && (
            showTooltips ? (
              <Tooltip title="Enhanced Profile">
                <CheckBadgeIcon className="h-16 w-16 text-blue-500" />
              </Tooltip>
            ) : (
              <CheckBadgeIcon className="h-16 w-16 text-blue-500" />
            )
          )}
	      {isHalespring && (
            showTooltips ? (
              <Tooltip title="Halespring Staff">
                <div><img className="w-20 h-20" src="assets/images/logo/HALESPRING-LOGO-100.png" alt="logo" /></div>
              </Tooltip>
            ) : (
              <div><img className="w-20 h-20" src="assets/images/logo/HALESPRING-LOGO-100.png" alt="logo" /></div>
            )
          )}
      </Stack>
  );
  
}


export default UserName;